import AppHeader from 'components/AppHeader'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppHeader
  },
  data: function () {
    return {
      callbackFlag: false,
      title: {
        content: '',
        startDate: null,
        endDate: null
      },
      validation: {
        hasContent: false,
        hasDate: false,
        isValidRange: true,
        isFuture: true,
        isAllClear: false
      }
    }
  },
  created () {
    this.search()
  },
  watch: {
    title: {
      deep: true,
      handler () {
        const today = new Date()
        this.validation.hasContent = this.title.content.length > 0
        this.validation.isFuture = this.title.startDate > today && this.title.endDate > today
        this.validation.hasDate = !!this.startDate && !!this.endDate
        if (this.validation.hasDate) {
          this.validation.isValidRange = this.title.startDate < this.title.endDate
        }
        this.validation.isAllClear = this.validation.hasContent && this.validation.isFuture && this.validation.hasDate && this.validation.isValidRange
      }
    }
  },
  computed: {
    ...mapGetters([
      'proposeTaskDetail'
    ]),
    startDate: function () {
      let result
      if ([null, undefined, ''].includes(this.title.startDate)) {
        result = null
      } else {
        const date = new Date(this.title.startDate)
        result = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      }
      return result
    },
    endDate: function () {
      let result
      if ([null, undefined, ''].includes(this.title.endDate)) {
        result = null
      } else {
        const date = new Date(this.title.endDate)
        result = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      }
      return result
    }
  },
  methods: {
    search: function () {
      const callback = () => {
        this.title.content = this.proposeTaskDetail.attributes['task-title']
        this.title.startDate = new Date(this.proposeTaskDetail.attributes['task-start-date'])
        this.title.endDate = new Date(this.proposeTaskDetail.attributes['task-end-date'])
        this.callbackFlag = true
      }
      this.$store.dispatch('PROPOSE_TASK_DETAIL', {id: this.$route.params.id, callback: callback})
    },
    deleteTask: function () {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('PROPOSE_TASK_DELETE', {id: this.$route.params.id, callback: this.goProposeTaskList})
      }
    },
    goProposeTaskList: function () {
      this.$router.push('/propose_task_list')
    },
    updateTask: function () {
      this.isDisabled = true
      const data = {
        'task_title': this.title.content,
        'task_start_date': this.startDate,
        'task_end_date': this.endDate
      }
      const id = this.$route.params.id
      const callback = () => {
        this.isDisabled = false
        this.goProposeTaskList()
      }
      this.$store.dispatch('PROPOSE_TASK_UPDATE', {data: data, id: id, callback: callback})
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/scripts/propose-task-edit.js